<template>
  <div class="subscribeInquiry big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">预约问诊记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 20px">
        <!-- 查询条件 -->
        <el-tabs v-model="inquiryForm.type" @tab-click="getList" type="card">
          <el-tab-pane label="待医生确认" name="1"></el-tab-pane>
          <el-tab-pane label="医生已确认" name="2"></el-tab-pane>
          <el-tab-pane label="已退款 " name="3"></el-tab-pane>
        </el-tabs>

        <div class="searchBox">
          <div class="item">
            <span class="title">患者姓名</span>
            <div class="item-content">
              <el-input
                v-model="inquiryForm.patient_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
              ></el-input>
            </div>
          </div>

          <div class="item">
            <span class="title">医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="inquiryForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
              ></el-input>
            </div>
          </div>

          <div class="item">
            <span class="title">医生手机</span>
            <div class="item-content">
              <el-input
                v-model="inquiryForm.doctor_phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
              ></el-input>
            </div>
          </div>

          <div class="item">
            <span class="title">预约问诊日期</span>
            <div class="item-content">
              <el-date-picker
                v-model="inquiryForm.inquiry_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="item" v-if="inquiryForm.type == 3">
            <span class="title" style="width: 56px; text-align: right"
              >备注</span
            >
            <div class="item-content">
              <el-input
                v-model="inquiryForm.refund_remark"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
              ></el-input>
            </div>
          </div>

          <div class="item" v-if="inquiryForm.type == 3">
            <span class="title">退款原因</span>
            <div class="item-content">
              <el-select
                v-model="inquiryForm.refund_desc"
                size="small"
                clearable
                placeholder="请选择"
                @change="getList"
              >
                <el-option
                  label="患者自助退款"
                  value="患者自助退款"
                ></el-option>
                <el-option label="未问诊退款" value="未问诊退款"></el-option>
                <el-option label="已问诊退款" value="已问诊退款"></el-option>
                <el-option label="超时未接诊" value="超时未接诊"></el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button type="primary" size="small" @click="getList"
              >查询</el-button
            >
            <el-button size="small" @click="restBtn">重置</el-button>
          </div>
        </div>

        <!-- 表格 -->
        <div class="inquiry-table">
          <el-table
            v-loading="tableLoading"
            :data="inquiryData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :align="item.align"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'pay_money'">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      问诊费用:&nbsp;{{ scope.row.consult_money }}元<br />
                      优惠券:&nbsp;-{{ scope.row.coupon_money }}元<br />
                      礼品卡:&nbsp;-{{ scope.row.gift_money }}元<br />
                      合计:&nbsp;{{ scope.row.pay_money }}元<br />
                    </div>
                    <span>{{ scope.row.pay_money }}</span>
                  </el-tooltip>
                </div>

                <div v-else-if="item.prop == 'user_info'">
                  <div>{{ scope.row.real_name }}</div>
                  <div>
                    <span>{{
                      scope.row.p_sex === 1
                        ? "男"
                        : scope.row.p_sex === 0
                        ? "未知"
                        : "女"
                    }}</span>
                    <span>{{ scope.row.age }}</span>
                  </div>
                </div>
                <div v-else-if="item.prop == 'doctor_info'">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                  >
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>
                    <span>{{
                      scope.row.d_sex === 1
                        ? "男"
                        : scope.row.p_sex === 0
                        ? "未知"
                        : "女"
                    }}</span>
                    <span>{{ scope.row.d_age }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </div>
                <div v-else-if="item.prop == 'register_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'register_mode'">
                  {{ scope.row[item.prop] | registerModeText }}
                </div>
                <div v-else-if="item.prop == 'week'">
                  {{ scope.row[item.prop] | weekText }}
                </div>
                <!-- <div v-else-if="item.prop == 'day_type'">
                  {{ scope.row[item.prop] === 1 ? '上午' : '下午' }}
                </div> -->

                <div v-else-if="item.prop == 'register_num'">
                  {{
                    String(scope.row[item.prop]).length === 1
                      ? `0${scope.row[item.prop]}`
                      : scope.row[item.prop]
                  }}
                </div>

                <!-- <div v-else-if="item.prop == 'refund_desc' && inquiryForm.type == 3">
                  {{scope.row[item.prop] }}
                </div> -->

                <div v-else>
                  {{ !scope.row[item.prop] ? "" : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="inquiryForm.type == 1"
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="!Number(scope.row.pay_money)"
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('824')
                      : false
                  "
                  @click="refundDia(scope.row)"
                  >退款</el-button
                >
                <el-button
                  type="text"
                  v-else
                  @click="refundDia(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('819')
                      : false
                  "
                  >退款</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />

        <!-- 预约问诊退款 -->
        <el-dialog
          title="预约问诊退款"
          :visible.sync="refundShow"
          width="520px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :before-close="beforeClose"
        >
          <div class="diaRefundbox">
            <div class="info-box">
              <div class="info-item">
                <p>
                  预约问诊日期: <span>{{ refund_info.wdate }}</span>
                </p>
                <p>
                  支付时间: <span>{{ refund_info.pay_time | dateFormat }}</span>
                </p>
              </div>
              <div class="info-item">
                <p>
                  患者: <span>{{ refund_info.real_name }}</span>
                </p>
                <p>
                  医生: <span>{{ refund_info.doctor_name }}</span>
                </p>
              </div>
              <div class="info-item">
                <p>
                  预约问诊费用: <span>{{ refund_info.pay_money }}</span>
                </p>
              </div>
            </div>

            <div class="align-center">
              <span class="searchtitle">退款原因</span>
              <el-select
                v-model="refundForm.refund_desc"
                placeholder="请选择"
                size="medium"
                style="margin-left: 10px; width: 300px"
              >
                <el-option
                  v-for="item in reasonOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>

            <div class="align-center">
              <span class="searchtitle">备注</span>
              <el-input
                v-model="refundForm.refund_remark"
                style="margin-left: 10px; width: 300px"
                type="textarea"
                :rows="3"
                placeholder="请填写退款备注"
              ></el-input>
            </div>

            <div class="align-center" v-if="refund_info.pay_money != 0">
              <span class="searchtitle">验证码</span>

              <el-input
                v-model="refundForm.code"
                size="medium"
                style="margin-left: 10px; width: 200px"
                placeholder="请输入"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getCode"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('820') : false
                "
                >{{ codeText }}</el-button
              >
            </div>
            <div
              style="padding-right: 200px; color: #ff9000"
              v-if="refund_info.pay_money != 0"
            >
              验证码有效时间3分钟
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelRefund">取 消</el-button>
            <el-button
              type="primary"
              :loading="isRefundOrder"
              @click="refundOrder"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import _ from "lodash";
import Pagination from "@/components/Pagination/index";
import activity from "../../../api/activity";
import common from "../../../api/common";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  components: {
    Pagination,
    DocMsg,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      inquiryForm: {
        type: "1",
        patient_name: "",
        doctor_name: "",
        doctor_phone: "",
        inquiry_time: [],
        refund_remark: "",
        refund_desc: "",
      },
      headers: [
        {
          label: "问诊发起时间",
          prop: "create_time",
          width: "180",
          align: "center",
          fixed: false,
        },
        {
          label: "预约问诊费用",
          prop: "consult_money",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "实付金额",
          prop: "pay_money",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "患者信息",
          prop: "user_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生信息",
          prop: "doctor_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "科室",
          prop: "department_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医院名称",
          prop: "hospital",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "预约问诊日期",
          prop: "wdate",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "预约模式",
          prop: "register_mode",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "周号",
          prop: "week",
          width: "auto",
          align: "center",
          fixed: false,
        },
        // {
        //   label: '出诊时段',
        //   prop: 'day_type',
        //   width: 'auto',
        //   align: 'center',
        //   fixed: false
        // },
        {
          label: "预约时间",
          prop: "register_time",
          width: "180",
          align: "center",
          fixed: false,
        },
        {
          label: "预约号码",
          prop: "register_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableHeader: [],
      inquiryData: [],
      refund_info: {},
      refundShow: false,
      refundForm: {
        refund_remark: "",
        code: "",
        refund_desc: "未问诊退款",
      },
      reasonOptions: [
        {
          label: "未问诊退款",
          value: 0,
        },
        {
          label: "已问诊退款",
          value: 1,
        },
      ],
      codeText: "获取验证码",
      timer: null,
      isRefundOrder: false,
      doc_msg: false,
      doctorId: "",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    weekText(val) {
      switch (val) {
        case "1":
          return "星期一";
        case "2":
          return "星期二";
        case "3":
          return "星期三";
        case "4":
          return "星期四";
        case "5":
          return "星期五";
        case "6":
          return "星期六";
        case "0":
          return "星期日";
      }
    },
    registerModeText(val) {
      switch (val) {
        case 1:
          return "全天预约模式";
        case 2:
          return "时间预约模式";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    // currentComponent() {
    //   switch (this.type) {
    //     case '1':
    //       return HomeBanner;
    //     case '2':
    //       return HomeDia;
    //     default:
    //       return HomeBanner;
    //   }
    // }
  },
  watch: {
    "inquiryForm.type": {
      handler(val, oldVal) {
        this.filterHeader();
      },
      deep: true,
    },
  },
  created() {
    this.filterHeader();
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    // 列表显示数据
    filterHeader() {
      let type = this.inquiryForm.type;
      switch (type) {
        case "1":
          this.tableHeader = this.headers;
          break;
        case "2":
          this.tableHeader = this.headers;
          break;
        case "3":
          this.tableHeader = this.headers.concat(
            {
              label: "退款原因",
              prop: "refund_desc",
              width: "auto",
              align: "center",
              fixed: false,
            },
            {
              label: "备注",
              prop: "refund_remark",
              width: "auto",
              align: "center",
              fixed: false,
            }
          );
          break;
        default:
          this.tableHeader = this.headers;
          break;
      }
    },
    // 列表
    getList() {
      let params = Object.assign(this.pagination, this.inquiryForm);
      params = _.omit(params, ["inquiry_time"]);
      let date_time = this.inquiryForm.inquiry_time;
      params["date_time_start"] = date_time ? date_time[0] : "";
      params["date_time_end"] = date_time ? date_time[1] : "";
      this.tableLoading = true;
      activity.consultRegisterList(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.inquiryData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    // 搜所
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 退款
    refundDia(row) {
      this.refund_info = row;
      this.refundShow = true;
    },
    // 退款弹窗关闭
    beforeClose(done) {
      this.cancelRefund();
      done();
    },
    // 重置
    restBtn() {
      for (let key in this.inquiryForm) {
        if (key === "inquiry_time") {
          this.inquiryForm[key] = [];
        } else {
          this.inquiryForm[key] = "";
        }
      }
    },
    // 获取验证码
    getCode: _.throttle(
      function () {
        if (!this.codeText.includes("获")) {
          this.$message.warning("验证码已发送");
          return;
        }
        if (this.refundForm.refund_remark == "") {
          this.$message.warning("请填写完内容");
          return;
        }

        let params = {};
        params = {
          type: 1,
          business_id: this.refund_info.register_id,
          price: this.refund_info.pay_money,
          refund_desc: this.refundForm.refund_desc,
        };

        console.log(params);

        common.refundverificode(params).then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("发送成功");
            let time = 60;
            this.timer = window.setInterval(() => {
              if (!time) {
                this.restCode();
                return;
              }
              time -= 1;
              this.codeText = `${time}S`;
            }, 1000);
            this.$once("hook:beforeDestroy", function () {
              this.restCode();
            });
          }
        });
      },
      5000,
      { trailing: false }
    ),
    // 重置验证码
    restCode() {
      window.clearInterval(this.timer);
      this.codeText = "获取验证码";
    },
    // 确认退款
    refundOrder() {
      if (this.refundForm.refund_remark === "") {
        this.$message.warning("请填写退款备注");
        return;
      }
      if (this.refundForm.code === "" && this.refund_info.pay_money > 0) {
        this.$message.warning("请填写验证码");
        return;
      }
      this.isRefundOrder = true;

      let params = Object.assign(this.refundForm, {
        register_id: this.refund_info.register_id,
      });
      let interfaceStr = "";
      if (this.refund_info.pay_money <= 0) {
        interfaceStr = "refundZeroConsultRegister";
        params = _.omit(params, ["code"]);
      } else {
        interfaceStr = "refundConsultRegister";
      }

      activity[interfaceStr](params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("退款成功");
            this.isRefundOrder = false;
            this.refund_info = {};
            this.getList();
            this.cancelRefund();
          }
        })
        .catch((err) => {
          this.isRefundOrder = false;
        });
    },
    // 取消退款
    cancelRefund(flag) {
      this.refundShow = false;
      this.restCode();
      for (let key in this.refundForm) {
        this.refundForm[key] = "";
      }
      this.refundForm["refund_desc"] = "未问诊退款";
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.subscribeInquiry {
  .searchBox {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      margin-bottom: 10px;
      .title {
        margin-right: 6px;
      }
      .item-content {
        .el-input {
          width: 160px;
        }
        .el-date-editor {
          width: 220px;
        }
      }
    }
  }
  .inquiry-table {
    border: solid 1px #c9cbd6;
  }
}
.diaRefundbox {
  .info-box {
    height: 110px;
    padding: 10px 20px;
    margin: 0;
    p {
      margin: 0;
      padding: 0;
      font-size: 15px;
    }
    span {
      font-size: 15px;
    }
    .info-item {
      display: flex;
      justify-content: space-between;
    }
  }
  .align-center {
    margin: 10px 0 10px;
    .searchtitle {
      width: 80px;
      text-align: right;
    }
  }
}
</style>
